import React from 'react'
import { FooterContainer } from './style'
import { useTranslation } from 'react-i18next'
import { useForm, SubmitHandler } from "react-hook-form";
import { HashLink as Link } from "react-router-hash-link"
import FooterTransparentLogo from "../../assets/images/logos/LOGO_1.png"
import AppStore from "../../assets/images/appstore.png"
import GooglePlay from "../../assets/images/googleplay.png"
import SaudiVision from "../../assets/images/logo-saudi-vision-2030.png"
import { ReactComponent as LogoSvg } from "../../assets/images/logos/Logo-svg.svg"
import { ReactComponent as LinkedIn } from "../../assets/icons/social-media/linkedin.svg"
// import { ReactComponent as Instagram } from "../../assets/icons/social-media/instagram.svg"
// import { ReactComponent as FaceBook } from "../../assets/icons/social-media/facebook.svg"
// import { ReactComponent as X } from "../../assets/icons/social-media/x.svg"
import { ReactComponent as Tiktok } from "../../assets/icons/social-media/tiktok.svg"
import { saveContact } from '../../apis/contact.api';
import { useAlert } from '../../context/AlertContext';
import { yupResolver } from '@hookform/resolvers/yup';

import * as yup from "yup";

const Footer = () => {
    const { t } = useTranslation()

    const { showAlert } = useAlert();

    // validation schema
    const schema = yup.object({
        fName: yup.string().required(t("fnameRequired")),
        lName: yup.string().required(t("lnameRequired")),
        email: yup.string().email(t("invalidEmail")).required(t("emailRequired")),
        phone: yup.string().required(t("phoneRequired")),
        message: yup
            .string()
            .required(t("messageRequired"))
            .min(10, t("messageMinLength")),
    }).required();

    type FormData = yup.InferType<typeof schema>;

    const { register, handleSubmit, reset, formState: { errors } } = useForm<FormData>({
        resolver: yupResolver(schema),
        defaultValues: {
            fName: "",
            lName: "",
            email: "",
            phone: "",
            message: "",
        }
    });

    const onSubmit: SubmitHandler<FormData> = data => {
        console.log(data)
        saveContact(data).then(() => {
            showAlert(t("contactSentSuccessfully"), "success");
            reset();
        }).catch(() => {
            showAlert(t("somethingWentWrong"), "error");
        });
    };

    return (
        <FooterContainer id="contact">
            <div className="footer-top">
                <div className='footer-text'>
                    <div className='footer-title'>{t("getInTouch")}</div>
                    <div className='footer-description'>{t("footerDescription")}</div>
                </div>
                <div className='footer-form'>
                    <form onSubmit={handleSubmit(onSubmit)} className='quote-form'>
                        <div className="form-row">
                            <div className="field-container">
                                <input placeholder={t("firstName")} {...register("fName")} className='form-field' />
                                <div className='field-error'>{errors.fName?.message}</div>
                            </div>
                            <div className="field-container">
                                <input placeholder={t("lastName")} {...register("lName")} className='form-field' />
                                <div className='field-error'>{errors.lName?.message}</div>
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="field-container">
                                <input placeholder={t("phone")} {...register("phone")} className='form-field' />
                                <div className='field-error'>{errors.phone?.message}</div>
                            </div>
                            <div className="field-container">
                                <input placeholder={t("email")} {...register("email")} className='form-field' />
                                <div className='field-error'>{errors.email?.message}</div>
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="field-container">
                                <textarea rows={4} placeholder={t("message")} {...register("message")} className='form-field full-width-field' />
                                <div className='field-error'>{errors.message?.message}</div>
                            </div>
                        </div>
                        <button type='submit' className='contact-btn'>{t("sendMessage")}</button>
                    </form>
                </div>
            </div>
            <div className='footer-middle'>
                <img src={FooterTransparentLogo} alt="logo" className='logo' />
                <img src={FooterTransparentLogo} alt="logo" className='logo' />
                <img src={FooterTransparentLogo} alt="logo" className='logo' />
                <img src={FooterTransparentLogo} alt="logo" className='logo' />
                <img src={FooterTransparentLogo} alt="logo" className='logo' />
                <img src={FooterTransparentLogo} alt="logo" className='logo' />
            </div>
            <div className="footer-bottom">
                <div className='footer-img'>
                    <img src={SaudiVision} alt="saudi-vision" className='saudi-vision' />
                </div>
                <div className='footer-menu'>
                    <div className='footer-bottom-title'>{t("menu")}</div>
                    <ul>
                        <li><Link to="#home" className="link">{t("home")}</Link></li>
                        <li><Link to="#about" className="link">{t("about")}</Link></li>
                        <li><Link to="#" className="link">{t("store")}</Link></li>
                        <li><Link to="#" className="link">{t("pricing")}</Link></li>
                        {/* <li><Link to="#" className="link">{t("projectManagement")}</Link></li> */}
                    </ul>
                </div>
                <div className='footer-menu'>
                    {/* <div className='footer-bottom-title'>{t("ourProductsAndCategories")}</div>
                    <ul>
                        <li>{t("plumbingTool")}</li>
                        <li>{t("doors")}</li>
                        <li>{t("cleaningSupplies")}</li>
                        <li>{t("buildingMaterials")}</li>
                    </ul> */}
                </div>
                <div className='footer-menu'>
                    <div className='footer-bottom-title'>{t("contact")}</div>
                    <ul>
                        <li>
                            <a
                                href="https://api.whatsapp.com/send/?phone=+966532963072&text=Hello+OnPoints"
                                target="_blank"
                                rel="noreferrer"
                                className='link'
                            >
                                966532963072
                            </a>
                        </li>
                        <li>
                            <a
                                href="mailto:info@onpoints.net"
                                target="_blank"
                                rel="noreferrer"
                                className='link'
                            >
                                info@onpoints.net
                            </a>
                        </li>
                    </ul>
                </div>
                <div className='footer-menu'>
                    <div className='footer-bottom-title'>{t("downloadApp")}</div>
                    <ul>
                        <li>
                            <a
                                href="/#"
                                target="_blank"
                                rel="noreferrer"
                                className='link'
                            >
                                <img src={AppStore} alt="app-store" className='download-app-img' />
                            </a>
                        </li>
                        <li>
                            <a
                                href="/#"
                                target="_blank"
                                rel="noreferrer"
                                className='link'
                            >
                                <img src={GooglePlay} alt="google-play" className='download-app-img' />
                            </a>
                        </li>
                    </ul>
                </div>
                <div className='footer-social-media-menu'>
                    <div className='footer-bottom-title'>{t("socialMedia")}</div>
                    <ul>
                        <li>
                            <LogoSvg />
                        </li>
                        <li className='social-media-icon'>
                            <a
                                href="https://www.linkedin.com/company/onpoint-logistic-services/?viewAsMember=true"
                                target="_blank"
                                rel="noreferrer"
                                className='link'
                            >
                                <LinkedIn />
                            </a>
                            {/* <a
                                href="/#"
                                target="_blank"
                                rel="noreferrer"
                                className='link'
                            >
                                <Instagram />
                            </a> */}
                            {/* <a
                                href="/#"
                                target="_blank"
                                rel="noreferrer"
                                className='link'
                            >
                                <FaceBook />
                            </a>
                            <a
                                href="/#"
                                target="_blank"
                                rel="noreferrer"
                                className='link'
                            >
                                <X />
                            </a> */}
                            <a
                                href="https://www.tiktok.com/@onpointlogistics0?_t=8shLyo5399z&_r=1"
                                target="_blank"
                                rel="noreferrer"
                                className='link'
                            >
                                <Tiktok />
                            </a>
                        </li>
                    </ul>
                </div>
                <div className='mobile-social-media'>
                    <div className='mobile-logos'>
                        <LogoSvg />
                        <img src={SaudiVision} alt="saudi-vision" className='saudi-vision' />
                    </div>
                </div>
                <div className='mobile-social-media-icon'>
                    <a
                        href="https://www.linkedin.com/company/onpoint-logistic-services/?viewAsMember=true"
                        target="_blank"
                        rel="noreferrer"
                        className='link'
                    >
                        <LinkedIn />
                    </a>
                    {/* <a
                        href="/#"
                        target="_blank"
                        rel="noreferrer"
                        className='link'
                    >
                        <Instagram />
                    </a>
                    <a
                        href="/#"
                        target="_blank"
                        rel="noreferrer"
                        className='link'
                    >
                        <FaceBook />
                    </a>
                    <a
                        href="/#"
                        target="_blank"
                        rel="noreferrer"
                        className='link'
                    >
                        <X />
                    </a> */}
                    <a
                        href="https://www.tiktok.com/@onpointlogistics0?_t=8shLyo5399z&_r=1"
                        target="_blank"
                        rel="noreferrer"
                        className='link'
                    >
                        <Tiktok />
                    </a>
                </div>
            </div>
            <div className='copyright'>
                <span>{t("developedBy")}</span> <a href='https://zane-co.com/' target="_blank" rel="noreferrer" className='link'>Zane Technology</a> &copy; 2024
            </div>
        </FooterContainer>
    )
}

export default Footer